import { useEffect, useState } from "react";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, AdminStatCard, EmptyState, StatusBadge, formatDate } from "./admin-ui";

function AdminDashboardPage() {
    const [data, setData] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        adminService.dashboard()
            .then(setData)
            .catch((error) => setMessage(error.message));
    }, []);

    const stats = data?.stats || {};
    const pendingJobs = data?.pendingJobs || [];
    const recentApplications = data?.recentApplications || [];

    return (
        <>
            <AdminPageHeader title="Admin Dashboard" subtitle="Platform Control Center" />
            {message && <div className="alert alert-info">{message}</div>}
            <div className="twm-dash-b-blocks mb-5">
                <div className="row">
                    <AdminStatCard icon="fa fa-clipboard-check" className="gradi-1" value={stats.pendingJobs} label="Pending Jobs" />
                    <AdminStatCard icon="fa fa-suitcase" className="gradi-2" value={stats.publishedJobs} label="Published Jobs" />
                    <AdminStatCard icon="fa fa-users" className="gradi-3" value={stats.candidates} label="Candidates" />
                    <AdminStatCard icon="fa fa-building" className="gradi-4" value={stats.employers} label="Employers" />
                    <AdminStatCard icon="fa fa-headset" className="gradi-1" value={stats.supportTickets} label="Open Support" />
                </div>
            </div>
            <div className="row">
                <div className="col-xl-7 col-lg-12 mb-4">
                    <AdminPanel title="Pending Moderation Queue" icon="fa fa-list-check">
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead><tr><th>Job</th><th>Company</th><th>Status</th><th>Created</th></tr></thead>
                                <tbody>
                                    {pendingJobs.length === 0 ? (
                                        <tr><td colSpan="4"><EmptyState text="No pending jobs right now." /></td></tr>
                                    ) : pendingJobs.map((job) => (
                                        <tr key={job.id}>
                                            <td>{job.title}<div className="text-muted">{job.location}</div></td>
                                            <td>{job.company_name || "Company"}</td>
                                            <td><StatusBadge status={job.status} /></td>
                                            <td>{formatDate(job.created_at)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </AdminPanel>
                </div>
                <div className="col-xl-5 col-lg-12 mb-4">
                    <AdminPanel title="Recent Applications" icon="fa fa-file-alt">
                        <div className="dashboard-list-box list-box-with-icon">
                            <ul>
                                {recentApplications.length === 0 ? (
                                    <li><i className="fa fa-info text-info list-box-icon" />No applications yet.</li>
                                ) : recentApplications.map((item) => (
                                    <li key={item.id}>
                                        <i className="fa fa-paperclip text-success list-box-icon" />
                                        {item.candidate_name} applied for <strong>{item.job_title}</strong>.
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </AdminPanel>
                </div>
            </div>
        </>
    );
}

export default AdminDashboardPage;
